import { createSelector } from '@ngrx/store';
import { selectLayoutState } from './layout.selectors';
import { selectRouterState } from '../../selectors';

export const selectLayoutContnetState = createSelector(
  selectLayoutState,
  (state) => state.content,
);

export const isMarginDisabled = createSelector(
  selectLayoutContnetState,
  selectRouterState,
  (state, routerState) =>
    state.disableMargin || routerState.state.data.disableMargin,
);
